var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['video', { first: _vm.first }]},[_c('div',{staticClass:"video-outer-wrapper"},[_c('VideoJs',{staticClass:"videojs",attrs:{"videoServer":_vm.block.video.src,"autoplay":false,"cc":_vm.block.video.cc}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e9ea940","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlogBlockTypes/Video.vue
// module id = null
// module chunks = 